/**
 * 出身背景数据
 * 凡间起点，决定初始资源和部分永久效果
 */

export interface Origin {
  id: string;
  name: string;
  desc: string;
  startingStones: number;
  startingItems: string[];
  /** 永久效果（直接作用于玩家属性的增减） */
  permAttackBonus?: number;
  permDefenseBonus?: number;
  permHpBonus?: number;
  permExpBonus?: number;    // 战斗经验倍率加成
  shopDiscount?: number;    // 坊市折扣 0.1 = 9折
  fleeBonus?: number;       // 逃跑概率加成
}

export const ORIGINS: Origin[] = [
  {
    id: 'cultivation_family',
    name: '修仙家族',
    desc: '家族中有低阶修士，从小耳濡目染，对修仙界的残酷早有认知。',
    startingStones: 150,
    startingItems: [],
    shopDiscount: 0.1,
  },
  {
    id: 'wealthy_mortal',
    name: '凡人富户',
    desc: '凡间的金银财宝在修士眼中不值一提，但至少让你起步时多了些盘缠。',
    startingStones: 80,
    startingItems: ['hp_pill', 'hp_pill'],
  },
  {
    id: 'farming_family',
    name: '凡人农家',
    desc: '寻常农家子弟，偶然被路过的修士发现身具灵根。这是最普通的开始，也是最多人的起点。',
    startingStones: 20,
    startingItems: ['hp_pill'],
  },
  {
    id: 'wandering_orphan',
    name: '流浪孤儿',
    desc: '无父无母，在市井中独自求生。早年的磨砺让你比同龄人更懂得如何在绝境中活下去。',
    startingStones: 0,
    startingItems: [],
    permExpBonus: 0.15,
  },
  {
    id: 'war_refugee',
    name: '战乱遗民',
    desc: '家乡被修仙者的斗法波及而毁灭。你亲眼见过修士的可怕，也因此学会了什么时候该跑。',
    startingStones: 5,
    startingItems: [],
    fleeBonus: 0.2,
  },
];

/** 加权随机出身 */
export function generateOrigin(): Origin {
  const weights = [10, 20, 40, 20, 10]; // 对应上面的顺序
  const total = weights.reduce((a, b) => a + b, 0);
  let roll = Math.random() * total;
  for (let i = 0; i < ORIGINS.length; i++) {
    roll -= weights[i];
    if (roll <= 0) return ORIGINS[i];
  }
  return ORIGINS[2]; // 默认凡人农家
}
